export const ROOT = 'superadmin';
export const ADMIN = 'admin';
export const CLIENT = 'client';
export const PROVIDER = 'provider';
export const CONTRACTOR = 'contractor';
export const USER = 'user';
